import { QueryClient } from '@tanstack/react-query';

import { useGetMagazinesQuery } from '@/hooks/magazine/mobile/magazine.gql.impl';
import * as Types from '@/types/bff/gql-schema';
import { GetMagazinesQuery } from '@/types/bff/gql-schema';
import { MagazineLineItemVo } from '@/types/magazine';
import dayjs from 'dayjs';

export const parseMagazineHomeNewest = (
  elements: Array<GetMagazinesQuery['magazineCursorPage']['elements'][0]>
): Array<MagazineLineItemVo> => {
  if (!elements) {
    return [];
  }

  return elements.map((magazine) => ({
    title: magazine.title,
    mobileTitle: magazine.mobileTitle,
    image: magazine.titleImageUrl,
    date: `${dayjs(magazine.createdAt).format('YYYY.MM.DD')}`,
    magazinePid: magazine.magazinePid,
    description: magazine.description,
    mobileDescription: magazine.mobileDescription,
  }));
};

const useGetMagazines = () => {
  const { data: magazines, isLoading: magazinesIsLoading } = useGetMagazinesQuery(
    {
      magazineCursorPageRequestInput: {
        size: 5,
      },
    },
    {
      select: (data) => parseMagazineHomeNewest(data.magazineCursorPage.elements),
    }
  );
  return {
    magazines: magazines ?? [],
    magazinesIsLoading,
  };
};

export default useGetMagazines;

useGetMagazines.prefetchQuery = async (queryClient: QueryClient, variables: Types.GetMagazinesQueryVariables) => {
  await queryClient.prefetchQuery(useGetMagazinesQuery.getKey(variables), useGetMagazinesQuery.fetcher(variables));
};

useGetMagazines.fetchQuery = async (queryClient: QueryClient, variables: Types.GetMagazinesQueryVariables) => {
  const response = await queryClient.fetchQuery(
    useGetMagazinesQuery.getKey(variables),
    useGetMagazinesQuery.fetcher(variables)
  );

  return response;
};
